import { spawn } from 'redux-saga/effects';

import { watchGetOrders } from './getOrders';

export default function* saga() {
  yield spawn(watchGetOrders);
}
